import styled from 'styled-components';

export const Section = styled.div`
  width: 100%;
  padding-top: 150px;
  padding-bottom: 64px;

  @media (max-width: 900px) {
    padding-top: 50px;
    padding-bottom: 64px;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 32px;
  padding-left: 32px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-center: space-between;
    gap: 45px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 32px;

  padding: 0 65px;
  margin-top: 20px;
  margin-left: -22px;

  width: 100%;
  height: 428px;
  background: #004f92;

  @media (max-width: 900px) {
    gap: 40px;
    margin: 0;
    padding: 0;
    height: 100%;
    background: transparent;
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: 0;
  color: #ffff;

  @media (max-width: 900px) {
    font-size: 32px;
    line-height: 40px;
    color: #004f92;
  }
`;

export const Description = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  color: #ffff;

  max-width: 500px;

  @media (max-width: 900px) {
    color: #898b8e;
    max-width: 100%;
  }
`;

export const ViewMore = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  color: #ffff;

  @media (max-width: 900px) {
    color: #898b8e;
    max-width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 326px;

  padding-top: 8px;

  @media (max-width: 900px) {
    padding: 0;
    max-width: 100%;
  }
`;

export const ImageSection = styled.img`
  max-width: 448px;
  max-height: 448px;

  @media (max-width: 900px) {
    max-width: 326px;
    max-height: 326px;
  }
`;

export const WrapperGrid = styled.div`
  display: grid;
  grid-template-columns: 25% 25% 25%;
  justify-content: center;
  gap: 48px;

  margin-top: 32px;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const Card = styled.div`
  background: #fbfbfb;
  padding: 24px 28px 24px 24px;
  border-radius: 16px;

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      width: 32px;
      height: 32px;
    }

    h1 {
      font-family: 'Montserrat', sans-serif;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      letter-spacing: 0;
      color: #004f92;
    }
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0;
    color: #898b8e;

    margin-top: 25px;
  }
`;
